import {NavDropdown} from "react-bootstrap";
import {AppNames, AppNumberToEnum, Apps, RootRoutes} from "enums";
import {FC, useContext} from "react";
import {AuthContext} from "contexts";
import {AvailableApp} from "services";
import {useNavigate} from "react-router-dom";
import {Envs} from "enums/Envs";

const DEFAULT_APPS = [Apps.Instinct, Apps.Flava, Apps.Spark];

interface Props {
    onHandleSwitch: (a: Apps) => void
}

export const AppDropdown: FC<Props> = ({onHandleSwitch}) => {
    const {app, env, availableApps, changeApp} = useContext(AuthContext);

    const navigate = useNavigate()

    const handleAvailableAppSwitch = async (a: AvailableApp) => {
        const didWork = await changeApp(AppNumberToEnum[a.appId], a.isTest);

        if (didWork) {
            navigate(RootRoutes.Moderation)
        } else {
            onHandleSwitch(AppNumberToEnum[a.appId])
        }
    }


    const renderAppsItems = () => {
        const isSingleSignInAvailable = !!availableApps;
        if (isSingleSignInAvailable) {
            return <>
                {availableApps.map(a => (
                    <NavDropdown.Item key={a.appId.toString() + a.isTest.toString()}
                                      onClick={() => handleAvailableAppSwitch(a)}>
                        {AppNames[a.appId] + ' ' + (a.isTest ? 'Test' : '')}
                    </NavDropdown.Item>
                ))}</>
        } else {
            return <>
                {DEFAULT_APPS.map(a => (
                    <NavDropdown.Item key={a} onClick={() => onHandleSwitch(a)}>
                        {a}
                    </NavDropdown.Item>
                ))}
            </>
        }
    }

    return <NavDropdown
        className="d-flex"
        title={
            <span className="text-secondary fw-bolder">
            {app} {env?.env === Envs.Test ? 'Test' : ''}</span>
        }
    >
        {renderAppsItems()}
    </NavDropdown>
}